// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import Switcher from '../utils/FormWidgets/Switcher';

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyleTitle = styled.div`
  font-size: 18px;
  vertical-align: bottom;
  margin-right: 20px;
`;

const StyleSwitcher = styled(Switcher)`
  padding-top: 10px;
  margin-top: 16px;
  margin-left: 50px;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartyActiveSwitcher = ({ party, changeStatus }) => {
  return (
    <StyledContainer>
      <StyleTitle>Active party</StyleTitle>
      <StyleSwitcher
        onChange={changeStatus}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        checked={party.partyStatus === 'pending'}
      />
    </StyledContainer>
  );
};

export default React.memo(PartyActiveSwitcher);
